import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { not, or } from 'ember-truth-helpers';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import SettingsPropertyTagsTablePropertyTags from 'lumen/components/settings/property-tags/table-property-tags';
import type MarketSettingsPropertyTagsController from 'lumen/controllers/market/settings/property-tags';

interface MarketSettingsPropertyTagsSignature {
  Args: {
    controller: MarketSettingsPropertyTagsController;
    model: unknown;
  };
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.property_tags.description"}}
    @isFullHeight={{true}}
    @title={{t "settings.property_tags.title"}}
  >
    <:headerAfter>
      <div class="flex gap-200">
        <PrismButton
          @buttonType="secondary"
          @isDisabled={{or
            (not @controller.hasUnsavedChanges)
            @controller.saveChangesTask.isRunning
          }}
          @label={{t "general.cancel"}}
          @onClick={{@controller.cancelChanges}}
          data-test-id="button-cancel"
        />
        <PrismButton
          @isDisabled={{or
            (not @controller.hasUnsavedChanges)
            @controller.saveChangesTask.isRunning
          }}
          @isLoading={{@controller.saveChangesTask.isRunning}}
          @label={{t "general.save"}}
          @onClick={{@controller.saveChangesTask.perform}}
          data-test-id="button-save"
        />
      </div>
    </:headerAfter>
    <:default>
      <SettingsPropertyTagsTablePropertyTags
        @isLoading={{@controller.model.propertyTags.isRunning}}
        @propertyTags={{@controller.propertyTags}}
      />
    </:default>
  </SettingsPageTemplate>
</template> satisfies TOC<MarketSettingsPropertyTagsSignature>;
